<template>
  <v-container>
    <v-row justify="center" align="stretch">
      <v-col
        v-for="item in items"
        :key="item.id"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card
          class="custom-card"
          :href="item.link"
          :target="item.newTab ? '_blank' : ''"
          :rel="item.newTab ? 'noopener noreferrer' : null"
          hover
          elevation="4"
        >
          <v-card-text class="card-content">
            <span class="card-title">{{ item.text }}</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "QuickAccess",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.custom-card {
  background-color: white;
  border-radius: 16px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.custom-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
}

.card-icon {
  color: #173c94;
  margin-bottom: 10px;
  transition: color 0.3s ease;
}

.custom-card:hover .card-icon {
  color: #0e2c7e;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #0e2c7e;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
